import { LayoutType } from '@goldcast/player-config/src/types/asset-types';

// Order the layout cards appear in the new grid. Values map 1:1 to the existing
// LayoutEnum; "Shared Fill" / "Film Strip" from the Figma are deferred to a
// later iteration (CR-10349), so GRID and FOCUS are kept as-is.
export const NEW_LAYOUT_CARD_ORDER: LayoutType[] = ['DEFAULT', 'GRID', 'FOCUS', 'PIP', 'SPEAKER', 'AUDIOGRAM'];

// UI-only placeholder controls. These have no persisted magicLayout field yet,
// so they are visual-only until a backend schema lands (CR-10349 follow-up).

// Aspect-ratio segmented selector. Superset of the real SizeType — `STANDARD`
// (4:5) has no persisted equivalent yet, so the whole control stays UI-only
// until the backend schema lands (CR-10349 follow-up).
export type AspectRatio = 'LANDSCAPE' | 'SQUARE' | 'PORTRAIT';

// `ratio` is width / height; the selector draws each option's preview box from it.
export const ASPECT_RATIO_SELECTOR_OPTIONS: { value: AspectRatio; label: string; ratio: number }[] = [
  { value: 'LANDSCAPE', label: '16:9', ratio: 16 / 9 },
  { value: 'SQUARE', label: '1:1', ratio: 1 },
  // { value: 'STANDARD', label: '4:5', ratio: 4 / 5 },
  { value: 'PORTRAIT', label: '9:16', ratio: 9 / 16 }
];

export type SpeakerPosition = 'LEFT' | 'RIGHT';
export type SpeakerTileShape = 'SQUARE' | 'ROUND';
export type PipCorner = 'TOP_LEFT' | 'TOP_RIGHT' | 'BOTTOM_LEFT' | 'BOTTOM_RIGHT';

export const SPEAKER_POSITION_OPTIONS: { value: SpeakerPosition; label: string }[] = [
  { value: 'LEFT', label: 'Left' },
  { value: 'RIGHT', label: 'Right' }
];

export const SPEAKER_TILE_SHAPE_OPTIONS: { value: SpeakerTileShape; label: string }[] = [
  { value: 'SQUARE', label: 'Square' },
  { value: 'ROUND', label: 'Round' }
];

export const PIP_CORNER_OPTIONS: PipCorner[] = ['TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', 'BOTTOM_RIGHT'];
